import { FetchResult, NormalizedCacheObject } from 'apollo-boost';

import { updateAdGroupRegions } from '../../graphql/mutations/grid/groups';
import { GdUpdateAdGroupRegionsInput, UpdateAdGroupRegions } from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class RegionsMutationExecutor {
    constructor(protected client: DNAApolloClient<NormalizedCacheObject>) {}

    public async updateAdGroupRegions(
        input: GdUpdateAdGroupRegionsInput,
        login: string
    ): Promise<FetchResult<UpdateAdGroupRegions>> {
        return this.client.awaitMutate<UpdateAdGroupRegions>({
            mutation: updateAdGroupRegions,
            variables: {
                input
            },
            login
        });
    }
}
